// removed by extract-text-webpack-plugin
module.exports = {"button":"_1c1Bu","hasIcon":"_3vh0q","buttonText":"_39DSx","primary":"_3I3LH","secondary":"_1ob4w","danger":"_2zwjw","icon":"_2cTsv"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Button/Button.css
// module id = 246
// module chunks = 0